import { Component, OnInit, OnDestroy, Input, ViewChild, isDevMode, AfterViewInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, forkJoin, of, Subscription, tap } from 'rxjs';
import { Address, ValidateAddressResponse } from 'src/app/domain/Address';
import { AppConfig } from 'src/app/domain/appconfig';
import { AddressService, AutoComplteItems } from 'src/app/services/address.service';
import { ConfigService } from 'src/app/services/app.config.service';
import { CountryService } from 'src/app/services/country.service';
import { CustomerService } from 'src/app/services/customer.service';
import { StepperService } from 'src/app/pages/Shared/stepper/stepper.service';
import { DateValidator } from '../../validators/date.validators';
import * as Leaflet from 'leaflet';
import { Router } from '@angular/router';
import { getLayers } from 'src/app/pages/dashboard/dashboard.component';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { customArray as CountryList } from 'country-codes-list';
import { AuthService, OBPermisssionsLocal } from 'src/app/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { DatesService } from 'src/app/services/dates.service';
import { ClientService } from 'src/app/services/client.service';
import { AliceDateSeletorComponent } from './AliceDateSeletor/AliceDateSeletor.component';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomerAddresessUpdateModalComponent } from './CustomerAddresessUpdateModal/CustomerAddresessUpdateModal.component';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  templateUrl: './address.component.html',
  selector: 'app-address',
  styleUrls: ['./address.component.scss'],
  providers: [DialogService],
})
export class AddressComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() header = 'Addresse';
  @Input() address = <Address>{};
  @Input() removeBtns: boolean = false;
  @ViewChild('name') name: any;
  @ViewChild('addressStreet') addressStreet: any;
  @ViewChild('aliceDateslector') aliceDateelector: AliceDateSeletorComponent;
  @ViewChild('addreseInput') addreseInput: AutoComplete;


  config: AppConfig;
  subscription: Subscription;
  holidays: any;
  foundAddresses = new Array<any>();
  foundAddresses$ = new BehaviorSubject<AutoComplteItems[]>(new Array<AutoComplteItems>());
  foundCustomers: any;
  selectedAddress: any;
  validatedAddress: boolean = false;
  countryCodes = CountryList({ value: '{countryCode}', label: '{countryNameEn}', callCode: '+{countryCallingCode}' });
  selectedPhoneCountry: any;
  formDisabled = false;
  setAddressMarker: any;
  addressIsValid = false;
  map: Leaflet.Map;
  options: Leaflet.MapOptions = {
    layers: getLayers(),
    zoom: 12,
    center: new Leaflet.LatLng(55.676098, 12.568337),
  };

  bookingType: any[] = [
    { label: 'Erhverv', value: 'Industry' },
    { label: 'Privat', value: 'Private' },
  ];
  colliTypes = [
    { name: 'Ldm', code: 'Ldm' },
    { name: 'Palle', code: 'Palle' },
    { name: 'Kasse', code: 'Kasse' },
  ];
  countries: any;
  contactPersons: any;

  filteredContactPersons: any;
  filteredDeliveryBefore: any;
  filteredDelivery: any;
  BookWithPickupDatePermission = OBPermisssionsLocal.BookWithPickupDate;
  isSenderForm: boolean = false;



  addressForm = new FormGroup(
    {
      name: new FormControl(this.address.name?.trim(), [requiredTrimmed, Validators.required]),
      street: new FormControl(this.address.street?.trim(), [requiredTrimmed, Validators.required]),
      date: new FormControl(null, Validators.required),
      contactPerson: new FormControl(),
      contactPhone: new FormControl(),
      contactEmail: new FormControl(null, [
        Validators.email,
        Validators.pattern(
          /^[A-Za-z0-9!#$%&amp;'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&amp;'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/
        ),
      ]),
      timeStart: new FormControl(),
      timeEnd: new FormControl(),
      saveAddress: new FormControl(),
      zipCode: new FormControl(this.address.zipCode?.trim(), [requiredTrimmed, Validators.required]),
      city: new FormControl(this.address.city?.trim(), [requiredTrimmed, Validators.required]),
      countryCode: new FormControl(this.address.countryCode?.trim(), [requiredTrimmed, Validators.required]),
      sendLabel: new FormControl({ value: this.address.sendLabel, disabled: true }),
      Street2: new FormControl(this.address.Street2 ?? this.address.street2 ?? ""),
      validatedBy: new FormControl(this.address.validatedBy),
      addresseId: new FormControl(null)
    },
    { validators: DateValidator.TimeStartTimeEndValidator }
  );
  showMissingZipCodeWarning = false;
  selectedCustomerForAddressUpdate: any = null;

  //#region DateSelector Parms
  DateSelectorStartDate: Date = new Date();
  MinDate: Date = new Date();

  pickupSameDayAllowed = this.authService.hasSetting('book.pickupdeliverysameday');
  IsAllowHoliyDayBooking = this.clientService.ClientAllowedToBookOnHoliDay;
  IsSender = this.router.url == '/booking/sender'; // quick hack for deffrenzing beteewd the adresseform state.
  //#endregion
  // kds sub
  private addressSearchSubscription?: Subscription;

  constructor(public configService: ConfigService, private addressService: AddressService, public stepperService: StepperService, private countryService: CountryService, private customerService: CustomerService,
    private router: Router, private authService: AuthService, private translateService: TranslateService, private dateService: DatesService, private clientService: ClientService, private dialogService: DialogService
  ) {
    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe((config) => this.config = config);
    this.bookingType = [{ label: 'Erhverv', value: 'Industry' }, { label: 'Privat', value: 'Private' },];
    this.checkFormData();

    const route = this.router.url;
    if (route == '/booking/sender') {
      this.address = this.stepperService.newShipment.senderAddress;
      if (this.stepperService.senderContactPersons && this.address.name) {
        this.contactPersons = this.stepperService.senderContactPersons;
      }
      this.header = this.translateService.instant('SENDER');
      this.addressForm.get('contactEmail').statusChanges.subscribe((status) => {
        if (status == 'INVALID') {
          this.addressForm.get('sendLabel').disable();
          this.addressForm.get('sendLabel').setValue(false);
        } else {
          this.addressForm.get('sendLabel').enable();
          // this.addressForm.controls.sendLabel.setValue(true);
        }
      });
      this.isSenderForm = true;
      if (!isDevMode()) {
        if (!this.authService.hasPermission(OBPermisssionsLocal.BookPickups)) {
          const controlsToDisable = ['name', 'street', 'zipCode', 'city', 'countryCode', 'contactPerson', 'contactPhone', 'contactEmail', 'timeStart', 'timeEnd', 'saveAddress'];

          controlsToDisable.forEach((control) => {
            this.addressForm.get(control)?.disable();
          });
          this.formDisabled = true;
        }
      }
    }
    if (route == '/booking/recipient') {
      this.address = this.stepperService.newShipment.recipientAddress;
      if (this.address.id != null && this.address.validatedBy == null)
        this.addressService.ValidateAddress(this.address.id);
      else
        this.showMissingZipCodeWarning = false;

      this.addressService.validationResult.subscribe({
        next: (x: any) => {
          if (!x.item)
            return;
          this.addressForm.controls.validatedBy.setValue(x.item?.validatedBy);
          this.address.validatedBy = x.item?.validatedBy;
          this.address.latitude = x.item.latitude;
          this.address.longitude = x.item.longitude;
        }, error: (x => { this.showMissingZipCodeWarning = !this.stepperService.newShipment.recipientAddress.validatedBy; })
      });


      this.addressForm.controls.validatedBy.addValidators(Validators.required)
      this.addressForm.controls.validatedBy.addValidators(Validators.min(3))

      if (this.stepperService.recipientContactPersons && this.address.name) {
        this.contactPersons = this.stepperService.recipientContactPersons;
      }
      this.header = this.translateService.instant('RECEIVER');
    }

    this.selectedPhoneCountry = this.countryCodes.find((c: any) => c.value == 'DK');
  }
  //!!! most of the bookingDate logic starts here !!!!
  ngOnInit(): void {
    this.fetchCountries();
    this.addressForm.patchValue({ countryCode: 'DK' }, { emitEvent: false }); // Default country

    if (this.address && this.address.street) {
      // Address was populated earlier
      this.addressForm.patchValue(
        {
          name: this.address.name,
          street: this.address.street,
          timeStart: this.address.timeStart,
          timeEnd: this.address.timeEnd,
          contactPhone: this.address.contactPhone,
          zipCode: this.address.zipCode,
          city: this.address.city,
          countryCode: this.address.countryCode,
          saveAddress: this.address.saveAddress,
          sendLabel: this.address.sendLabel,
          Street2: this.address.Street2 ?? this.address.street2 ?? '',
          validatedBy: this.address.validatedBy
        },
        { emitEvent: false }
      );

      if (this.address.contactEmail && this.address.contactEmail !== '')
        this.addressForm.patchValue({ contactEmail: this.address.contactEmail }, { emitEvent: false });
      if (this.address.contactPerson)
        this.addressForm.patchValue({ contactPerson: { name: this.address.contactPerson } }, { emitEvent: false });
      if (this.addressForm.controls.contactEmail.valid && this.addressForm.controls.contactEmail.value) {
        this.addressForm.get('sendLabel').enable();
        this.addressForm.patchValue({ sendLabel: true }, { emitEvent: false });
        this.address.sendLabel = true;
      }

      if (this.stepperService.resetBookingDate)
        this.stepperService.resetBookingDate = false;

    } else {
      if (!this.address?.date) {
        if (this.router.url === '/booking/recipient') {
          this.hardcodedStenaCheckRemoveASAP(); // REMOVE THIS WHEN POSSIBLE
        }
      }
    }

    this.MinDate = this.MinDateSelector();
    let initialDate = this.StartDateSelector();

    this.DateSelectorStartDate = new Date(initialDate);
    let normalizedDate = this.formatShipmentDate(initialDate);

    this.addressForm.controls.date.setValue(normalizedDate, { emitEvent: false });
    this.address.date = normalizedDate;

    if (this.router.url === '/booking/sender')
      this.stepperService.newShipment.senderAddress.date = normalizedDate;
    else if (this.router.url === '/booking/recipient')
      this.stepperService.newShipment.recipientAddress.date = normalizedDate;

    this.addressForm.controls.date.updateValueAndValidity({ emitEvent: false });
    this.addressForm.controls.Street2.valueChanges.subscribe(x => { this.address.Street2 = x; });
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    this.name?.nativeElement?.focus();
  }

  useMap() {
    this.setAddressMarker = !this.setAddressMarker;
  }

  onPhoneCountryChange(event: any) {
    if (this.addressForm.controls.contactPhone.value) {
      const isValidPhone = isValidPhoneNumber(this.addressForm.controls.contactPhone.value, this.selectedPhoneCountry.value);
      if (!isValidPhone) {
        this.addressForm.controls.contactPhone.setErrors({ invalid: true });
      } else {
        this.addressForm.controls.contactPhone.setErrors(null);
      }
    }
  }

  onMapReady(map: Leaflet.Map) {
    this.map = map.setView([55.9396761, 9.5155848], 7);

    Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(this.map);

    this.map.on('click', (event: any) => {
      Leaflet.marker(event.latlng, {
        icon: Leaflet.icon({
          ...Leaflet.Icon.Default.prototype.options,
          iconUrl: '/assets/layout/images/marker-icon.png',
          shadowUrl: '/assets/layout/images/marker-shadow.png',
        }),
      }).addTo(this.map);
    });
  }

  filterContactPersons(event: any) {
    if (!this.contactPersons) {
      this.filteredContactPersons = [];
      return;
    }
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.contactPersons.length; i++) {
      let contactPerson = this.contactPersons[i];
      if (query)
        if (contactPerson.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
          filtered.push(contactPerson);
        }
    }

    this.filteredContactPersons = filtered;
  }

  onContactPersonSelect(event: any) {
    this.addressForm.controls.contactPhone.setValue(event.phone);
    this.addressForm.controls.contactEmail.setValue(event.email);
    this.addressForm.controls.contactPerson.setValue(event.name);
    // this.addressForm.patchValue({
    //   contactPhone: event.phone,
    //   contactEmail: event.email,
    //   contactPerson: { name: event.name },
    // });
    if (this.isSenderForm) {
      this.addressForm.controls.sendLabel.setValue(event.sendLabel);
      // this.addressForm.patchValue({ sendLabel: event.sendLabel });
    }
    this.address.contactPerson = event.name;
  }

  hardcodedStenaCheckRemoveASAP() {
    if (this.clientService.clientTenantName == 'tjw' && this.clientService.defaultClientNumber == '43964246') {
      // Stena
      this.stepperService.newShipment.recipientAddress.name = 'LOOP/Electronic';
      this.stepperService.newShipment.recipientAddress.city = 'Roskilde';
      this.stepperService.newShipment.recipientAddress.zipCode = '4000';
      this.stepperService.newShipment.recipientAddress.countryCode = 'DK';
      this.stepperService.newShipment.recipientAddress.contactEmail = 'info@loop-eletronic.dk';
      this.stepperService.newShipment.recipientAddress.contactPhone = '40454133';
      this.stepperService.newShipment.recipientAddress.street = 'Navervej 19';
      this.stepperService.newShipment.recipientAddress.latitude = 55.63852;
      this.stepperService.newShipment.recipientAddress.longitude = 12.11967;
      this.addressForm.patchValue({
        name: this.stepperService.newShipment.recipientAddress.name,
        street: this.stepperService.newShipment.recipientAddress.street,
        zipCode: this.stepperService.newShipment.recipientAddress.zipCode,
        city: this.stepperService.newShipment.recipientAddress.city,
        countryCode: this.stepperService.newShipment.recipientAddress.countryCode,
        contactEmail: this.stepperService.newShipment.recipientAddress.contactEmail,
        contactPhone: this.stepperService.newShipment.recipientAddress.contactPhone,
      });
    }
  }

  goToNextStep() {
    let zipCode = this.addressForm.controls.zipCode.getRawValue();

    if (!zipCode?.toString().trim()) {
      this.addressForm.controls.zipCode.enable();
      this.addressForm.controls.zipCode.setErrors({ required: true });
      this.addressForm.controls.zipCode.markAsDirty();
      return;
    }

    if (this.addressForm.valid) {
      this.stepperService.stepNext();
    }
  }

  fetchCountries() {
    if (!this.countries) {
      this.countries = this.countryService.getClientCountries();
    }
  }

  onTimeStartComplete() {
    if (this.addressForm.controls.timeStart.value) {
      if (
        this.addressForm.controls.timeStart.value.length == 5 &&
        parseInt(this.addressForm.controls.timeStart.value.substring(0, 2)) <= 23 &&
        parseInt(this.addressForm.controls.timeStart.value.substring(3, 5)) <= 59
      ) {
        this.address.timeStart = this.addressForm.controls.timeStart.value + ":00";
      } else {
        this.address.timeStart = null;
        this.addressForm.controls.timeStart.setValue(this.addressForm.controls.timeStart.value);
        this.addressForm.controls.timeStart.setErrors({ invalid: true });
      }
    }
  }

  onTimeEndComplete() {
    if (this.addressForm.controls.timeEnd.value) {
      if (
        this.addressForm.controls.timeEnd.value.length == 5 &&
        parseInt(this.addressForm.controls.timeEnd.value.substring(0, 2)) <= 23 &&
        parseInt(this.addressForm.controls.timeEnd.value.substring(3, 5)) <= 59
      ) {
        this.address.timeEnd = this.addressForm.controls.timeEnd.value + ":00";
      } else {
        this.address.timeEnd = null;
        this.addressForm.controls.timeEnd.setValue(this.addressForm.controls.timeEnd.value);
        this.addressForm.controls.timeEnd.setErrors({ invalid: true });
      }
    }
  }

  checkFormData() {
    this.addressForm.valueChanges.subscribe((data) => {
      this.address.sendLabel = data.sendLabel;
      this.address.timeStart = data.timeStart && data.timeStart == 'hh:mm' ? null : this.address.timeStart;
      this.address.timeEnd = data.timeEnd && data.timeEnd == 'hh:mm' ? null : this.address.timeEnd;

      if (data.street)
        this.address.street = data.street;
      if (this.addressForm.controls.name.valid)
        this.address.name = data.name;
      if (data.contactPhone) {
        if (this.selectedPhoneCountry) {
          const isValidPhone = isValidPhoneNumber(data.contactPhone, this.selectedPhoneCountry.value);
          if (isValidPhone) {
            this.addressForm.controls.contactPhone.setErrors(null);
            this.address.contactPhone = data.contactPhone;
          } else {
            this.addressForm.controls.contactPhone.setErrors({ invalid: true });
          }
        } else {
          this.addressForm.controls.contactPhone.setErrors({ isRequired: true });
        }
      }
      this.address.contactPhone = data.contactPhone;

      if (data.zipCode) {
        this.address.zipCode = data.zipCode;
      }
      if (data.city) {
        this.address.city = data.city;
      }
      if (data.countryCode) {
        this.address.countryCode = data.countryCode;
      }
      if (this.addressForm.controls.contactEmail.valid) {
        if (!this.addressForm.controls.contactEmail.value || this.addressForm.controls.contactEmail.value == '') {
          this.addressForm.controls.sendLabel.disable({ emitEvent: false });
          this.addressForm.controls.sendLabel.setValue(false, { emitEvent: false });
        }
        this.address.contactEmail = data.contactEmail;
      }
      if (this.addressForm.controls.contactPerson.valid) {
        if (data.contactPerson && data.contactPerson.hasOwnProperty('name')) {
          this.address.contactPerson = data.contactPerson.name;
        } else {
          this.address.contactPerson = data.contactPerson;
        }
      }
      this.address.saveAddress = data.saveAddress;
    });
  }

  onClearAddress() {
    this.validatedAddress = false;
    this.enableAddressFields();
    this.clearAddressForm(false);
    this.addressForm.markAsPristine();
    this.addressStreet?.inputEL?.nativeElement?.focus();
    this.stepperService.DisableNextStep();
  }

  onClearCustomer() {
    this.showMissingZipCodeWarning = false;
    this.selectedCustomerForAddressUpdate = null;
    this.clearAddressForm(true);
    this.enableAddressFields();
    this.addressForm.markAsPristine();
    if (!this.isSenderForm)
      this.stepperService.ResetrecerpiatnCustomer();
    this.contactPersons = null;
    this.filteredContactPersons = null;
    this.name?.inputEL?.nativeElement?.focus();
  }

  clearAddressForm(includeContact: boolean) {
    this.validatedAddress = false;
    this.addressForm.patchValue({ street: '', zipCode: '', city: '', countryCode: 'DK' });
    this.address.street = '';
    this.address.city = '';
    this.address.zipCode = '';
    this.address.countryCode = '';
    this.address.latitude = null;
    this.address.longitude = null;
    if (includeContact) {
      this.addressForm.patchValue({ name: '', contactPerson: null, contactEmail: null, contactPhone: null });
      this.address.name = '';
      this.address.contactPerson = null;
      this.address.contactPhone = null;
      this.address.contactEmail = null;
    }
    this.stepperService.DisableNextStep();
  }

  enableAddressFields() {
    this.addressForm.get('zipCode').enable();
    this.addressForm.get('city').enable();
    this.addressForm.get('countryCode').enable();
  }

  disableAddressFields(disableCountryCode) {
    this.addressForm.get('zipCode').disable();
    this.addressForm.get('city').disable();
    if (disableCountryCode) {
      this.addressForm.get('countryCode').disable();
    }
  }

  onClearContactPerson(event: any) {
    this.addressForm.patchValue({ contactPerson: null, contactEmail: null, contactPhone: null, sendLabel: false });
    this.address.contactPerson = null;
    this.address.contactEmail = null;
    this.address.contactPhone = null;
    this.address.sendLabel = false;
  }


  setAddress(event: any) {
    if (event?.validatedBy === 'KDS' && event.isForslag == true) {
      this.addreseInput.search(null, event.street, null);
      // this.searchAddress( {query:event.street});
    }

    if ((event.street + "").match(/\d+/) == null && event.isForslag == false) {
      this.addreseInput.search(null, event.street + " " + event.zipCode, null);
      return;
    }

    if (event?.validatedBy === 'KDS' && event?.kdsId) {
      this.addressService.resolveKdsAddress(event.kdsId)
        .subscribe({
          next: resolvedAddress => { this.applyAddress(resolvedAddress); },
          error: error => {
            console.error('Could not resolve KDS address', error);
            this.validatedAddress = false;
          }
        });
      this.validatedAddress = true;
      return;
    }
    this.applyAddress(event);
  }

  setCustomer(cust: any) {
    this.addressForm.controls.name.setValue(cust.name);
    this.addressForm.controls.addresseId.setValue(cust.address.id);
    // this.addressForm.patchValue({ name: cust.name });
    if (this.router.url == '/booking/sender') {
      this.stepperService.senderCustomer = cust;
    }
    if (this.router.url == '/booking/recipient') {
      this.stepperService.recipientCustomer = cust;
      this.showMissingZipCodeWarning = false;
      this.selectedCustomerForAddressUpdate = cust;

    }

    if (cust.contactPersons) {
      this.contactPersons = cust.contactPersons;

      if (this.router.url == '/booking/sender') {
        this.stepperService.senderContactPersons = this.contactPersons;
      }
      if (this.router.url == '/booking/recipient') {
        this.stepperService.recipientContactPersons = this.contactPersons;
      }
    }

    if (cust.contactPerson) {
      // this.addressForm.patchValue({ contactPerson: { name: cust.contactPerson.name }, contactEmail: cust.contactPerson.email, contactPhone: cust.contactPerson.phone });
      this.addressForm.controls.contactPerson.setValue({ name: cust.contactPerson.name });
      this.addressForm.controls.contactEmail.setValue(cust.contactPerson.email);
      this.addressForm.controls.contactPhone.setValue(cust.contactPerson.phone);
      if (this.isSenderForm) {
        // this.addressForm.patchValue({ sendLabel: cust.contactPerson.sendLabel });
        this.addressForm.controls.sendLabel.setValue(cust.contactPerson.sendLabel);
      }
      this.address.contactPerson = cust.contactPerson.name;
      this.address.contactPhone = cust.contactPerson.phone;
      this.address.contactEmail = cust.contactPerson.email;
      if (cust.contactPerson.sendLabel && this.isSenderForm) {
        this.address.sendLabel = cust.contactPerson.sendLabel;
      }
    }

    if (cust.address) {
      this.validatedAddress = true || cust.address.validatedBy != null;
      this.setAddress(cust.address);

      // when no addrese was found gives the optaion to update customer addrese
      let isRecipientStep = this.router.url == '/booking/recipient';
      let missingZipCode = !cust.address.zipCode || cust.address.zipCode.toString().trim() === '';

      if (isRecipientStep && (missingZipCode || cust.address.validatedBy == null)) {
        this.selectedCustomerForAddressUpdate = cust;
        this.enableAddressFields();

        this.addressForm.controls.zipCode.setErrors({ required: true });
        this.addressForm.controls.zipCode.markAsDirty();
        this.addressForm.controls.zipCode.updateValueAndValidity();
      }
    }

    if (!cust.contactPerson) {
      this.addressForm.patchValue({ contactPerson: null, contactEmail: null, contactPhone: null, sendLabel: false });
      this.address.contactPerson = null;
      this.address.contactPhone = null;
      this.address.contactEmail = null;
      this.address.sendLabel = false;
    }
    this.FirePriceCheckEvent();
  }

  formattedStreetName(item: Address) {
    // If Address is chosen (Auto Complete)
    if (item && item.street) {
      return `${item.street}`;
    }
    // if Address is manually typed
    if (item) {
      return `${item}`;
    }
    return '';
  }

  formattedCustomerName(item: any) {
    if (item && item.name) {
      return `${item.name}`;
    }
    if (item) {
      return `${item}`;
    }
    return '';
  }

  clearOnSearch() {
    this.address.city = '';
    this.address.zipCode = '';
    this.address.countryCode = '';
    this.address.latitude = null;
    this.address.longitude = null;
    this.address.validatedBy = null;
    this.addressForm.patchValue({ zipCode: '', city: '', countryCode: '' });
    this.stepperService.DisableNextStep();
  }

  searchCustomer(event: any) {
    if (this.authService.hasPermission(OBPermisssionsLocal.ShowCustomers))
      this.customerService.searchCustomerFormatted(event.query).subscribe(
        (result: any) => {
          if (result) {
            this.foundCustomers = result;
          }
        },
        (error: any) => {
          this.foundCustomers = [];
        }
      );
    else
      this.foundCustomers = [];
  }

  isDev() {
    return isDevMode()
  }

  checkHidePrevBtn() {
    if (this.stepperService.activeIndex == 0) {
      return true;
    }
    return false;
  }

  FirePriceCheckEvent() {
    window.dispatchEvent(new CustomEvent("CheckPriceEvent", {}));
  }

  StartDateSelector_v1(): Date {
    let isSender = this.router.url === '/booking/sender';
    let savedDate = this.parseShipmentDate(isSender ? this.stepperService.newShipment.senderAddress.date : this.stepperService.newShipment.recipientAddress.date);

    let minDate = this.MinDateSelector();
    let selectedDate = savedDate && savedDate >= minDate ? new Date(savedDate) : new Date(minDate);
    let weekendsBlocked = isSender || this.clientService.clientTenant === 'Eurofins' || !this.IsAllowHoliyDayBooking;

    if (weekendsBlocked) {
      while (selectedDate.getDay() === 0 || selectedDate.getDay() === 6) {
        selectedDate.setDate(selectedDate.getDate() + 1);
      }
    }

    return selectedDate;
  }

  SetDateFromEvent(eventValue: any): void {
    let selectedDate = this.parseShipmentDate(eventValue?.event);
    if (!selectedDate)
      return;

    let isSender = this.router.url === '/booking/sender';
    let isRecipient = this.router.url === '/booking/recipient';
    let minDate = this.MinDateSelector();
    let date = selectedDate < minDate ? new Date(minDate) : new Date(selectedDate);
    // only for euroFins and IsAllowHoliyDayBooking also acounts for sameday date thingy
    let weekendsBlocked = isSender || this.clientService.clientTenant === 'Eurofins' || !this.IsAllowHoliyDayBooking;

    if (weekendsBlocked) {
      while (date.getDay() === 0 || date.getDay() === 6) {
        date.setDate(date.getDate() + 1);
      }
    }

    let normalizedDate = this.formatShipmentDate(date);
    this.DateSelectorStartDate = new Date(date);
    this.addressForm.controls.date.setValue(normalizedDate, { emitEvent: true });
    this.address.date = normalizedDate;

    // updates shipmentPreview
    if (isSender) {
      this.stepperService.newShipment.senderAddress.date = normalizedDate;
    } else if (isRecipient) {
      this.stepperService.newShipment.recipientAddress.date = normalizedDate;
    }
  }

  MinDateSelector(): Date {

    let now = new Date();
    let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    let minDate = new Date(today);

    let isRecipient = this.router.url === '/booking/recipient';


    // if (isRecipient && this.clientService.clientTenant !== 'Eurofins' && !this.pickupSameDayAllowed) {
    //   const nextDay = this.getRecipientStartDate();
    //   if (nextDay)
    //     return nextDay;
    // }

    if (isRecipient) {
      let senderDate = this.parseShipmentDate(this.stepperService.newShipment.senderAddress.date);

      if (this.clientService.clientTenant === 'Eurofins' && this.pickupSameDayAllowed) {
        return new Date(senderDate);
      }

      if (this.pickupSameDayAllowed) {
        minDate.setDate(minDate.getDate());
        // let nextDay = this.getRecipientStartDate();
        // if (nextDay)
        //   return nextDay;
        return minDate;
      }

      if (senderDate && senderDate > minDate)
        minDate = new Date(senderDate);
      else if (!this.pickupSameDayAllowed)
        minDate.setDate(minDate.getDate() + 1);
    }

    let weekendsBlocked = this.router.url === '/booking/sender' || this.clientService.clientTenant === 'Eurofins' || !this.IsAllowHoliyDayBooking;

    if (weekendsBlocked) {
      while (minDate.getDay() === 0 || minDate.getDay() === 6) {
        minDate.setDate(minDate.getDate() + 1);
      }
    }

    return minDate;
  }

  CheckAddreseFields() {
    let disable = false;

    if (!this.addressForm.valid)
      disable = true
    if (this.addressForm.controls.zipCode && this.addressForm.controls.zipCode.value)
      disable = true
    if (this.addressForm.controls.city && this.addressForm.controls.city.value)
      disable = true;

    return disable;
  }

  openCustomerAddressUpdateModal() {
    this.dialogService.open(CustomerAddresessUpdateModalComponent, {
      header: 'Opdater kundeadresse',
      width: '50%',
      data: { custoemrId: this.selectedCustomerForAddressUpdate.id, addressForm: this.addressForm, addressId: this.selectedCustomerForAddressUpdate.address.id },
    }).onClose.subscribe((updatedAddress: Address | undefined) => {
      if (!updatedAddress) {
        return;
      }
      this.addressForm.patchValue({
        street: updatedAddress.street,
        zipCode: updatedAddress.zipCode,
        city: updatedAddress.city,
        countryCode: updatedAddress.countryCode,
        Street2: updatedAddress.Street2,
        validatedBy: updatedAddress.validatedBy
      });

      this.address.street = updatedAddress.street;
      this.address.zipCode = updatedAddress.zipCode;
      this.address.city = updatedAddress.city;
      this.address.countryCode = updatedAddress.countryCode;
      this.address.latitude = updatedAddress.latitude;
      this.address.longitude = updatedAddress.longitude;
      this.address.validatedBy = updatedAddress.validatedBy;
      this.address.Street2 = updatedAddress.Street2;
      this.address.id = updatedAddress.id;

      this.showMissingZipCodeWarning = !updatedAddress.zipCode;
      this.customerService.updateCustomerAddress(this.address, this.selectedCustomerForAddressUpdate.id).subscribe(x => console.log("updateAddrese ", x));

      this.FirePriceCheckEvent();
    });
  }

  // this compines both backend autocomp and new KDS (replacment for DAWA)
  searchAddress(event: any) {
    this.clearOnSearch();
    const search = event.query?.trim();
    if (!search) {
      this.addressSearchSubscription?.unsubscribe();
      this.foundAddresses = [];
      return;
    }
    this.addressSearchSubscription?.unsubscribe();
    this.addressSearchSubscription = forkJoin({
      api: this.addressService.autoCompleteAddress(search) // backend autocomplte
        .pipe(catchError(error => {
          console.error('Internal address autocomplete failed', error);
          return of({ items: [] } as any);
        })
        ),

      kds: this.addressService.KdsAutocomplete(search)
    })
      .subscribe({
        next: ({ api, kds }) => {
          let apiAddresses = api?.items ?? [];
          let filterdAddresr = apiAddresses as any[];
          apiAddresses = filterdAddresr.filter(x => kds.findIndex(y => y.street == x.street) == -1)
          this.foundAddresses = [...kds, ...apiAddresses];
        },
        // next: ({ api, kds }) => {
        //   let addresses = [...kds, ...(api?.items ?? [ ])]; 
        //   // let prioritized = [...addresses.filter(x => x.validatedBy === 'MongoDB'), ...addresses.filter(x => x.validatedBy !== 'MongoDB')];
        //   this.foundAddresses = [...api, ...kds];
        //   // let prioritized = addresses;
        //   // let seen = new Set<string>();

        //   // this.foundAddresses = prioritized.filter(address => {
        //   //   let key = [address.street, address.houseNumber, address.postalCode].map(x => String(x ?? '').trim().toLowerCase()).join('|');

        //   //   if (seen.has(key)) return false;

        //   //   seen.add(key);
        //   //   return true;
        //   // });
        // },

        error: error => {
          console.error('Address search failed', error);
          this.foundAddresses = [];
        }
      });
  }

  private applyAddress(event: any) {
    this.validatedAddress = true;
    let disableCountryCode = true;

    if (!event.countryCode) {
      disableCountryCode = false;
      this.addressForm.controls.countryCode.setValidators(Validators.required);
      this.addressForm.controls.countryCode.markAsDirty();
      this.addressForm.controls.countryCode.updateValueAndValidity();
    }

    const existingAddressId = this.addressForm.controls.addresseId.getRawValue();

    if (existingAddressId != null && this.address.validatedBy == null) {
      this.addressService.ValidateAddress(existingAddressId);
      this.addressService.validationResult
        .subscribe({
          next: x => {
            if (!x.item)
              return;

            if ((x as ValidateAddressResponse).item?.validatedBy != null) {
              event.validatedBy = (x as ValidateAddressResponse).item.validatedBy;
              this.showMissingZipCodeWarning = false;
              this.addressForm.controls.validatedBy.setValue((x as ValidateAddressResponse).item.validatedBy);
            }
          },
          error: () => {
            this.showMissingZipCodeWarning = true;
          }
        });
    }

    this.addressForm.patchValue({
      street: event.street,
      zipCode: event.zipCode,
      Street2: event.street2,
      city: event.city,
      countryCode: event.countryCode,
      validatedBy: event.validatedBy
    });

    this.disableAddressFields(disableCountryCode);
    this.address.street = event.street;
    this.address.city = event.city;
    this.address.zipCode = event.zipCode;
    this.address.countryCode = event.countryCode;
    this.address.latitude = event.latitude;
    this.address.longitude = event.longitude;
    this.address.validatedBy = event.validatedBy;
  }

  //#region Helpers
  // format Date to Date from string | Date | null 
  private parseShipmentDate(value: any): Date | null {
    if (!value)
      return null;

    if (value instanceof Date) {
      if (isNaN(value.getTime()))
        return null;
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    if (typeof value === 'string') {
      let parts = value.trim().split('/');

      if (parts.length !== 3) {
        return null;
      }

      let day = Number(parts[0]);
      let month = Number(parts[1]);
      let year = Number(parts[2]);

      if (!day || !month || !year) {
        return null;
      }

      let date = new Date(year, month - 1, day);
      if (date.getDate() !== day || date.getMonth() !== month - 1 || date.getFullYear() !== year)
        return null;
      return date;
    }

    return null;
  }

  private formatShipmentDate(date: Date): string {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
  //#endregion

  StartDateSelector(): Date {
    let isSender = this.router.url === '/booking/sender';

    if (!isSender && this.clientService.clientTenant !== 'Eurofins') {
      let nextDay = this.getRecipientStartDate();
      if (nextDay)
        return nextDay;
    }
    if (!isSender && this.clientService.clientTenant === 'Eurofins') {
      return new Date(this.stepperService.newShipment.senderAddress?.date ?? this.MinDate);
    }

    let savedDate = this.parseShipmentDate(
      this.stepperService.newShipment.senderAddress.date
    );

    let minDate = this.MinDateSelector();
    let selectedDate =
      savedDate && savedDate >= minDate
        ? new Date(savedDate)
        : new Date(minDate);

    let weekendsBlocked =
      isSender ||
      this.clientService.clientTenant === 'Eurofins' ||
      !this.IsAllowHoliyDayBooking;

    if (weekendsBlocked) {
      while (selectedDate.getDay() === 0 || selectedDate.getDay() === 6) {
        selectedDate.setDate(selectedDate.getDate() + 1);
      }
    }

    return selectedDate;
  }

  private getRecipientStartDate(): Date | null {
    const senderDate = this.parseShipmentDate(
      this.stepperService.newShipment.senderAddress.date
    );

    if (!senderDate) return null;

    const nextDay = new Date(senderDate);
    nextDay.setDate(nextDay.getDate() + 1);

    return nextDay;
  }

}


export function requiredTrimmed(control: AbstractControl): ValidationErrors | null {
  let value = control.value;
  if (typeof value === 'string' && value.trim().length === 0)
    return { required: true };
  return Validators.required(control);
}


